(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"]) return;
  try {
    
  const faqElements = document.querySelectorAll('.faq-block');

  if (!Shopify.designMode) {
    faqElements.forEach((faqElement) => {
      faqElement.addEventListener('mouseover', (e) => {
        faqElement.querySelector('details').setAttribute('open', 'open');
      });
      faqElement.addEventListener('mouseleave', (e) => {
        faqElement.querySelector('details').removeAttribute('open');
      });
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      console.log(e.detail.blockId);
      const selectedBlock = e.detail.blockId;
      if (!selectedBlock.includes('faq')) return;

      document.querySelector(`#${selectedBlock} details`).setAttribute('open', 'open');
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      console.log(e.detail.blockId);
      const selectedBlock = e.detail.blockId;
      if (!selectedBlock.includes('faq')) return;

      document.querySelector(`#${selectedBlock} details`).removeAttribute('open');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-classes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('classes-overview')) {
    customElements.define(
      'classes-overview',
      class ClassesOverview extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          if (this._initialised) return;
          this._initialised = true;
          this.heroMap = {};
          this.init();
        }

        get heroCount() {
          return Object.keys(this.heroMap).length;
        }

        init() {
          // build a map of heros
          this.querySelectorAll('.class-hero').forEach((hero) => {
            this.heroMap[hero.dataset.classIndex] = hero;
          });

          // get active button and hero
          this.activeButton = this.querySelector('.class-button.is-active');
          this.activeHero = this.querySelector('.class-hero:not(.hidden)');

          // set up event delegation
          this.addEventListener('click', (e) => {
            const clickedButton = e.target.closest('.class-button');
            if (!clickedButton) return;

            // Don't process if clicking on already active button
            if (clickedButton.classList.contains('is-active')) return;

            console.log('click');

            const index = clickedButton.dataset.buttonIndex;
            const nextHero = this.heroMap[index];

            this.activateButton(clickedButton);
            this.deactivateButton(this.activeButton);

            this.showHero(nextHero);
            this.hideHero(this.activeHero);

            this.activeButton = clickedButton;
            this.activeHero = nextHero;
          });

          // set up arrows
          this.addEventListener('click', (e) => {
            const clickedArrow = e.target.closest('[data-direction]');
            if (!clickedArrow) return;

            let { direction, classIndex } = clickedArrow.dataset;
            classIndex = parseInt(classIndex);
            let nextHeroIndex;

            if (direction == 'prev') {
              nextHeroIndex = classIndex - 1;
              // check if we're on the first item
              if (classIndex == 1) {
                nextHeroIndex = this.heroCount;
              }
            }

            if (direction == 'next') {
              nextHeroIndex = classIndex + 1;
              // check if we're on the last item
              if (classIndex == this.heroCount) {
                nextHeroIndex = 1;
              }
            }

            const nextButton = this.querySelector(`.class-button[data-button-index="${nextHeroIndex}"]`);
            const nextHero = this.heroMap[nextHeroIndex];

            this.activateButton(nextButton);
            this.deactivateButton(this.activeButton);

            this.showHero(this.heroMap[nextHeroIndex]);
            this.hideHero(this.activeHero);

            this.activeButton = nextButton;
            this.activeHero = nextHero;
          });
        }

        deactivateButton(buttonEl) {
          buttonEl.classList.remove('bg-(--highlight)', 'text-black', 'is-active');
        }

        activateButton(buttonEl) {
          buttonEl.classList.add('bg-(--highlight)', 'text-black', 'is-active');
        }

        showHero(heroEl) {
          heroEl.classList.remove('hidden');
        }

        hideHero(heroEl) {
          heroEl.classList.add('hidden');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq-page"]) return;
  try {
    
  const faqElements = document.querySelectorAll('.faq-block');

  if (!Shopify.designMode) {
    faqElements.forEach((faqElement) => {
      faqElement.addEventListener('mouseover', (e) => {
        faqElement.querySelector('details').setAttribute('open', 'open');
      });
      faqElement.addEventListener('mouseleave', (e) => {
        faqElement.querySelector('details').removeAttribute('open');
      });
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      console.log(e.detail.blockId);
      const selectedBlock = e.detail.blockId;
      if (!selectedBlock.includes('faq')) return;

      document.querySelector(`#${selectedBlock} details`).setAttribute('open', 'open');
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      console.log(e.detail.blockId);
      const selectedBlock = e.detail.blockId;
      if (!selectedBlock.includes('faq')) return;

      document.querySelector(`#${selectedBlock} details`).removeAttribute('open');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faqs"] && !Shopify.designMode) return;
  try {
    
  const faqElements = document.querySelectorAll('.faq-block');

  if (!Shopify.designMode) {
    faqElements.forEach((faqElement) => {
      faqElement.addEventListener('mouseover', (e) => {
        faqElement.querySelector('details').setAttribute('open', 'open');
      });
      faqElement.addEventListener('mouseleave', (e) => {
        faqElement.querySelector('details').removeAttribute('open');
      });
    });
  }

  if (Shopify.designMode) {
    document.addEventListener('shopify:block:select', (e) => {
      console.log(e.detail.blockId);
      const selectedBlock = e.detail.blockId;
      if (!selectedBlock.includes('faq')) return;

      document.querySelector(`#${selectedBlock} details`).setAttribute('open', 'open');
    });
    document.addEventListener('shopify:block:deselect', (e) => {
      console.log(e.detail.blockId);
      const selectedBlock = e.detail.blockId;
      if (!selectedBlock.includes('faq')) return;

      document.querySelector(`#${selectedBlock} details`).removeAttribute('open');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-homepage-hero"] && !Shopify.designMode) return;
  try {
    
  const playVideoBtn = document.querySelector('[data-open-video]');
  const videoDialog = document.querySelector('#video_dialog');
  const videoEl = videoDialog.querySelector('video');
  playVideoBtn.addEventListener('click', (e) => {
    videoDialog.showModal();
    videoEl.play();
  });

  videoDialog.addEventListener('close', (e) => {
    console.log('close');
    videoEl.pause();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-memberships-hero"] && !Shopify.designMode) return;
  try {
    
  const playVideoBtn = document.querySelector('[data-play-video]');
  const pauseVideoBtn = document.querySelector('[data-pause-video]');
  const videoDialog = document.querySelector('#video_dialog');
  const videoOverlay = document.querySelectorAll('[data-video-overlay]');
  const videoEl = document.querySelector('video');
  playVideoBtn.addEventListener('click', (e) => {
    handleVideoPlay();
    videoOverlay.forEach((overlay) => {
      overlay.classList.add('opacity-0');
    });
  });

  pauseVideoBtn.addEventListener('click', (e) => {
    handleVideoPause();
    videoOverlay.forEach((overlay) => {
      overlay.classList.remove('opacity-0');
    });
  });

  function handleVideoPlay() {
    playVideoBtn.classList.add('hidden');
    pauseVideoBtn.classList.remove('hidden');
    videoEl.play();
  }

  function handleVideoPause() {
    playVideoBtn.classList.remove('hidden');
    pauseVideoBtn.classList.add('hidden');
    videoEl.pause();
  }

  } catch(e) { console.error(e); }
})();
})();
